export interface LeadEnterpriseResponse {
    id: number;
    nomeEmpresa: string;
    nomeContato: string;
    email: string;
    telefone: string;
    cnpj: string | null;
    quantidadeFuncionarios: string | null;
    mensagem: string | null;
    dataCadastro: Date;
    dataAtendimento: Date | null;
    atendidoPorId: number | null;
    atendidoPorNome: string | null;
    status: StatusLeadEnterprise;
    statusDescricao: string;
    observacoes: string | null;
    valorNegociado: number | null;
    dataConversao: Date | null;
    checkoutToken: string | null;
    checkoutUrl: string | null;
    checkoutExpiraEm: Date | null;
    imobiliariaConvertidaId: number | null;
    imobiliariaConvertidaNome: string | null;
}

export enum StatusLeadEnterprise {
    Pendente = 0,
    EmAtendimento = 1,
    Convertido = 2,
    Cancelado = 3
}

export interface AtualizarStatusLeadRequest {
    status: StatusLeadEnterprise;
    observacoes?: string;
}

export interface ConverterLeadRequest {
    valorMensal: number;
    observacoes?: string;
}

export interface ConverterLeadResponse {
    sucesso: boolean;
    message: string;
    checkoutToken?: string;
    checkoutUrl?: string;
}

export interface EstatisticasLeadEnterprise {
    pendentes: number;
    emAtendimento: number;
    convertidos: number;
    cancelados: number;
    total: number;
}

export interface ListaLeadsResponse {
    items: LeadEnterpriseResponse[];
    total: number;
}
